import { useEffect, useState } from 'react';
import type { ThemeColorsMeta } from '@frameio/vapor';
import { theme, usePrevious } from '@frameio/vapor';
import { GRAPHEME_LIMIT, GRAPHEMES_REMAINING_TO_WARN } from './constants';
import { StyledCircle, StyledDiv } from './GraphemeLimit.styles';

export type GrahemeLimitProps = {
  graphemeCount: number;
  graphemeMaximumCount?: number;
};

export const GraphemeLimit = ({
  graphemeCount,
  graphemeMaximumCount = GRAPHEME_LIMIT,
  ...other
}: GrahemeLimitProps) => {
  const [bgColor, setBgColor] = useState<ThemeColorsMeta>('yellow');
  const remainingGraphemes = graphemeMaximumCount - graphemeCount;
  const previousBgColor = usePrevious(bgColor);

  useEffect(() => {
    if (remainingGraphemes > GRAPHEMES_REMAINING_TO_WARN) return;
    if (remainingGraphemes > 0) {
      setBgColor('yellow');
    } else if (remainingGraphemes <= 0) {
      setBgColor('orange');
    }
  }, [remainingGraphemes]);

  return (
    <>
      {remainingGraphemes <= GRAPHEMES_REMAINING_TO_WARN && (
        <StyledDiv>
          <StyledCircle
            key={remainingGraphemes}
            $bgColor={theme.colors.meta.opaque[bgColor]}
            $previousBgColor={previousBgColor}
            {...other}
          >
            {remainingGraphemes}
          </StyledCircle>
        </StyledDiv>
      )}
    </>
  );
};
